import { Box, Container, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ProductCard from "../../components/cards/ProductCard";
import ProductCardSkeleton from "../../components/skeletons/ProductCardSkeleton";
import { useSnackbar } from "../../lib/context/snackbarContext";
import { getTopRatedProducts } from "../../services/productsFn";
import { t } from "i18next";

const TopProducts = () => {
  const { showSnackbar } = useSnackbar();
  const [allProducts, setAllProducs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchAllProducts();
  }, []);

  const fetchAllProducts = async () => {
    try {
      setIsLoading(true);
      const response = await getTopRatedProducts();
      if (response.data.status === "success") {
        let data = response.data.data;
        setAllProducs(data);
      }
    } catch (error) {
      showSnackbar(error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box component={"section"} bgcolor={"text.raisinBlack"} py={6}>
      <Typography
        variant="heading_pr"
        component={"h1"}
        color={"text.white"}
        textAlign={"center"}
      >
        {t("homeExporeHead")}
      </Typography>
      <Container maxWidth={"lg"} sx={{ mt: 3 }}>
        <Grid container spacing={2} mt={5}>
          {isLoading
            ? Array.from({ length: 5 }).map((_, index) => (
                <Grid key={index} item xs={6} sm={4} md={2.4}>
                  <ProductCardSkeleton />
                </Grid>
              ))
            : allProducts?.map((item, index) => (
                <Grid key={index} item xs={6} sm={4} md={2.4}>
                  <ProductCard cardData={item} />
                </Grid>
              ))}
        </Grid>

        {isLoading === false && allProducts?.length === 0 && (
          <Typography
            variant="h4"
            fontWeight={600}
            color={"white"}
            textAlign={"center"}
            textTransform={"capitalize"}
          >
            {t("noProductsFound")} !!
          </Typography>
        )}
      </Container>
    </Box>
  );
};

export default TopProducts;

// import { Box, Container, Grid, Typography } from "@mui/material";
// import React, { useEffect, useState, useRef } from "react";
// import ProductCard from "../../components/cards/ProductCard";
// import ProductCardSkeleton from "../../components/skeletons/ProductCardSkeleton";
// import { useSnackbar } from "../../lib/context/snackbarContext";
// import { getTopRatedProducts } from "../../services/productsFn";

// const TopProducts = () => {
//   const { showSnackbar } = useSnackbar();
//   const [allProducts, setAllProducs] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const observerRef = useRef(null); // Reference to the section
//   const [hasFetched, setHasFetched] = useState(false); // Flag to avoid multiple fetches

//   // Function to handle API call
//   const fetchAllProducts = async () => {
//     if (hasFetched) return; // Prevent multiple fetches if already done
//     setIsLoading(true);
//     try {
//       const response = await getTopRatedProducts();
//       if (response.data.status === "success") {
//         let data = response.data.data;
//         setAllProducs(data);
//         setHasFetched(true); // Set flag to true to avoid further fetches
//       }
//     } catch (error) {
//       showSnackbar(error?.message);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Intersection Observer to trigger the API call when the component is in the viewport
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           fetchAllProducts(); // Call the API when in view
//           observer.disconnect(); // Disconnect after the first call
//         }
//       },
//       { threshold: 0.5 } // Trigger when 50% of the component is in view
//     );

//     if (observerRef.current) {
//       observer.observe(observerRef.current); // Start observing the component
//     }

//     // Cleanup observer on component unmount
//     return () => {
//       if (observerRef.current) {
//         observer.disconnect();
//       }
//     };
//   }, [hasFetched]); // Only trigger effect once to avoid repeated calls

//   return (
//     <Box component={"section"} bgcolor={"text.raisinBlack"} py={6} ref={observerRef}>
//       <Typography
//         variant="heading_pr"
//         component={"h1"}
//         color={"text.white"}
//         textAlign={"center"}
//       >
//         Explore Top Rated Products
//       </Typography>
//       <Container maxWidth={"lg"} sx={{ mt: 3 }}>
//         <Grid container spacing={2} mt={5}>
//           {isLoading
//             ? Array.from({ length: 5 }).map((_, index) => (
//                 <Grid key={index} item xs={12} sm={4} md={2.4}>
//                   <ProductCardSkeleton />
//                 </Grid>
//               ))
//             : allProducts?.map((item, index) => (
//                 <Grid key={index} item xs={12} sm={4} md={2.4}>
//                   <ProductCard cardData={item} />
//                 </Grid>
//               ))}
//         </Grid>

//         {/* Display a message when no products are found */}
//         {isLoading === false && allProducts?.length === 0 && (
//           <Typography
//             variant="h4"
//             fontWeight={600}
//             color={"white"}
//             textAlign={"center"}
//           >
//             No Product Found !!
//           </Typography>
//         )}
//       </Container>
//     </Box>
//   );
// };

// export default TopProducts;
